import { render, staticRenderFns } from "./_MenuSuporte.vue?vue&type=template&id=613aa059&scoped=true&"
import script from "./_MenuSuporte.vue?vue&type=script&lang=js&"
export * from "./_MenuSuporte.vue?vue&type=script&lang=js&"
import style0 from "./_MenuSuporte.vue?vue&type=style&index=0&id=613aa059&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613aa059",
  null
  
)

export default component.exports